const env = process.env.VUE_APP_RUN_ENV //https://static.nfapp.southcn.com/hd/reportPropagate/index.html部署路径

let baseUrl = {
  dev: "https://devreveal.nfapp.southcn.com/nfplus-reveal/",
  test: "https://testreveal.nfapp.southcn.com/nfplus-reveal/",
  pro: "https://reveal.nfapp.southcn.com/nfplus-reveal/",
  mock: "",
  proxy: "/api/nfplus-reveal"
}[env]

const NETWORK_ERR_MSG = "加载失败，请稍后再试"

const UPDATE_VERSION = 610

export { baseUrl, env, UPDATE_VERSION, NETWORK_ERR_MSG }
